module.exports = __webpack_public_path__ + "static/media/gallery15.6c8fe0e5.jpg";